/**
 * Feb 2026 — Backwards-compatibility shim for share links that were
 * minted or shared using the shorter `/s/:slug` shape (without the
 * `/api` prefix). The backend short-link resolver lives at
 * `/api/s/:slug` — Live Stock and Outstanding links have always used
 * the `/api/s/...` form, but a small window of Export Orders Timeline
 * links leaked the `/s/...` shape and landed on the React catch-all
 * (which rendered the maintenance / Home page). This component just
 * bounces the browser to the real resolver, preserving the query
 * string so any downstream `?t=...` token continues to work.
 */
import React, { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';

const ShortLinkRedirect = () => {
  const { slug } = useParams();
  const location = useLocation();

  useEffect(() => {
    if (!slug) return;
    // Preserve the query string so signed-token links keep working.
    const suffix = location.search || '';
    // Use `replace` so the broken URL doesn't sit in the history stack.
    window.location.replace(`/api/s/${encodeURIComponent(slug)}${suffix}`);
  }, [slug, location.search]);

  return (
    <div style={{
      minHeight: '60vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', flexDirection: 'column',
      fontFamily: "'Inter', system-ui, sans-serif", color: '#334155',
    }}>
      <div style={{ fontSize: 42, marginBottom: 12 }}>&#128279;</div>
      <div style={{ fontSize: 15, fontWeight: 600 }}>Opening your share link…</div>
      <div style={{ fontSize: 12, marginTop: 6, color: '#64748B' }}>
        If nothing happens in 3 seconds,&nbsp;
        <a href={`/api/s/${encodeURIComponent(slug || '')}${location.search || ''}`}
           style={{ color: '#0078D4', textDecoration: 'underline' }}>
          continue here
        </a>.
      </div>
    </div>
  );
};

export default ShortLinkRedirect;
